export const projects = {
  projects: [
    "Crud Full Stack Application",
    "Text Based Game (Battle Simulator)",
    "Lexical Analyzer (FLEX)",
    "Parallel Data Mining (Testing Algorithms)",
    "Online Notebook",
    "Portfolio",
    "Plane Booking Form",
    "E-Mail Application",
    "Bank Application",
    "Phone Contact Directory",
  ],
};
